export default "__VITE_ASSET__CXAra0nt__"